"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const formik_1 = require("formik");
const LogFormikErrors = () => {
    const formik = (0, formik_1.useFormikContext)();
    (0, react_1.useEffect)(() => {
        if (!formik.isValid) {
            console.debug('Formik Errors', formik.errors);
        }
    }, [formik]);
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
};
exports.default = LogFormikErrors;
//# sourceMappingURL=index.js.map